import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import common from './common'
import ui from './ui'
import user from './user'
const host = window.location.host
const devTools =
	process.env.REACT_APP_HOST === host
		? false
		: process.env.REACT_APP_TEST_HOST === host
		? false
		: false // view for redux development logs
const store = configureStore({
	devTools,
	reducer: {
		common,
		ui,
		user,
	},
	middleware: getDefaultMiddleware => {
		if (devTools) {
			return getDefaultMiddleware({ serializableCheck: false }).concat(logger)
		} else {
			return getDefaultMiddleware({ serializableCheck: false })
		}
	},
})
export default store
